import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { slot: "button" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-comments" }),
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-danger navbar-badge" }, "4")
], -1)
const _hoisted_2 = { slot: "menu" }
const _hoisted_3 = {
  href: "#",
  class: "dropdown-item"
}
const _hoisted_4 = { class: "media" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "media-body" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "dropdown-item-title" }, [
    /*#__PURE__*/_createTextVNode(" Brad Diesel "),
    /*#__PURE__*/_createElementVNode("span", { class: "float-right text-sm text-danger" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Call me whenever you can..."),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-muted" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock mr-1" }),
    /*#__PURE__*/_createTextVNode(" 4 Hours Ago ")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_7 = {
  href: "#",
  class: "dropdown-item"
}
const _hoisted_8 = { class: "media" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "media-body" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "dropdown-item-title" }, [
    /*#__PURE__*/_createTextVNode(" John Pierce "),
    /*#__PURE__*/_createElementVNode("span", { class: "float-right text-sm text-muted" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "I got your message bro"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-muted" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock mr-1" }),
    /*#__PURE__*/_createTextVNode(" 4 Hours Ago ")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_11 = {
  href: "#",
  class: "dropdown-item"
}
const _hoisted_12 = { class: "media" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "media-body" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "dropdown-item-title" }, [
    /*#__PURE__*/_createTextVNode(" Nora Silvester "),
    /*#__PURE__*/_createElementVNode("span", { class: "float-right text-sm text-warning" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "The subject goes here"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-muted" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock mr-1" }),
    /*#__PURE__*/_createTextVNode(" 4 Hours Ago ")
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item dropdown-footer"
}, "See All Messages", -1)

export function render(_ctx, _cache) {
  const _component_pf_image = _resolveComponent("pf-image")
  const _component_pf_dropdown = _resolveComponent("pf-dropdown")

  return (_openBlock(), _createBlock(_component_pf_dropdown, { "hide-arrow": "" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_pf_image, {
              src: require('@/assets/img/default-profile.png'),
              alt: "User Avatar",
              width: "50",
              class: "mr-2",
              rounded: ""
            }, null, 8, ["src"]),
            _hoisted_5
          ])
        ]),
        _hoisted_6,
        _createElementVNode("a", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_pf_image, {
              src: require('@/assets/img/default-profile.png'),
              alt: "User Avatar",
              class: "mr-2",
              width: "50",
              rounded: ""
            }, null, 8, ["src"]),
            _hoisted_9
          ])
        ]),
        _hoisted_10,
        _createElementVNode("a", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_pf_image, {
              src: require('@/assets/img/default-profile.png'),
              alt: "User Avatar",
              class: "mr-2",
              width: "50",
              rounded: ""
            }, null, 8, ["src"]),
            _hoisted_13
          ])
        ]),
        _hoisted_14,
        _hoisted_15
      ])
    ]),
    _: 1
  }))
}